import React from "react";
import Envelope from "./Envelope";

function App() {
  return (
    <div className="App">
      <h1>&#x1FA75; 1st Anniversary &#x1FA75;</h1>
      <Envelope />
    </div>
  );
}

export default App;
